import NameOfHelper from "../helpers/nameOfHelper";
import {routesConst} from "../routes.js";

export default class AuthService
{
    public secToShowRefreshModal = 300; // 5 min
    private store = <any|null>null;
    private $router = <any|null>null;

    constructor(store, $router) {
        this.store = store;
        this.$router = $router;
    }
    public init(): void {
        // Ensure customer refresh token ask
        if (! this.store.getters["customer/isLoggedIn"]) {
            return;
        }
        this.checkTokenExpiration();
    }

    private checkTokenExpiration(): void {
        const interval = setInterval(() => {
            const now = new Date().getTime() / 1000; // ms to s
            const expTime = new Date(this.store.state.customer.expire_time).getTime() / 1000;

            if ((Math.floor(expTime) - Math.floor(now)) > 0) {
                if ( (Math.floor(expTime) - Math.floor(now)) <= this.secToShowRefreshModal) {
                    this.store.commit('customer/SET_STATE_PROP_VALUE', [
                        {prop: 'sessionEnd', value: true}
                    ]);
                }
                return;
            }

            const state = this.store.state.customer;
            const nameOf = (c) => NameOfHelper.obj(c);
            this.store.commit( 'customer/SET_STATE_PROP_VALUE', [
                {prop: nameOf(() => state.token), value: null},
                {prop: nameOf(() => state.expire_time), value: null},
                {prop: nameOf(() => state.first_name), value: null},
                {prop: nameOf(() => state.last_name), value: null},
                {prop: nameOf(() => state.email), value: null},
                {prop: nameOf(() => state.mobno), value: null},
                {prop: nameOf(() => state.company_name), value: null},
                {prop: nameOf(() => state.company_number), value: null},
                {prop: nameOf(() => state.company_vat), value: null},
                {prop: nameOf(() => state.address), value: null},
                {prop: nameOf(() => state.sessionEnd), value: false},
            ]);
            // this.store.commit('customer/CLEAR_STATE');
            this.$router.push(routesConst.LOGIN)

            clearInterval(interval);
        }, 15000);
    }
}